(function () {
  const canvas = document.getElementById("sally-arcade");
  if (!canvas) return;

  const arcadeScreen = canvas.closest(".arcade-screen") || canvas.parentElement;
  const displayCtx = canvas.getContext("2d");
  displayCtx.imageSmoothingEnabled = false;
  const W = canvas.width;
  const H = canvas.height;
  const PLAYER_STORAGE_KEY = "sallyArcadePlayer:v1";
  const EMAIL_MAX_LENGTH = 64;
  const INSTAGRAM_MAX_LENGTH = 30;
  const LEADERBOARD_LIMIT = 10;
  const DEFAULT_LEADERBOARD_API_URL = "https://sallysupply-arcade-leaderboard.vercel.app/api/leaderboard";
  let memoryStoredPlayer = null;
  const crtBuffer = document.createElement("canvas");
  crtBuffer.width = W;
  crtBuffer.height = H;
  const ctx = crtBuffer.getContext("2d");
  ctx.imageSmoothingEnabled = false;
  const mobileEntry = createMobileEntryForm();
  const mobileEntryForm = mobileEntry.form;
  const mobileEntrySubmit = mobileEntry.submit;
  const mobileEntryLeaderboard = mobileEntry.leaderboard;
  const mobileEntryFields = mobileEntry.fields;
  const mobileEntryWrappers = mobileEntry.wrappers;
  const mobileEntryInputs = Object.values(mobileEntryFields);
  const leaderboardModal = createLeaderboardModal();
  const colors = {
    black: "#050505",
    paper: "#d8ccb6",
    beige: "#aa9b84",
    red: "#b83a2e",
    blue: "#2c5362",
    muted: "#675f55",
  };
  const pixelFont = {
    " ": ["...", "...", "...", "...", "...", "...", "..."],
    A: [".###.", "#...#", "#...#", "#####", "#...#", "#...#", "#...#"],
    B: ["####.", "#...#", "#...#", "####.", "#...#", "#...#", "####."],
    C: [".####", "#....", "#....", "#....", "#....", "#....", ".####"],
    D: ["####.", "#...#", "#...#", "#...#", "#...#", "#...#", "####."],
    E: ["#####", "#....", "#....", "####.", "#....", "#....", "#####"],
    F: ["#####", "#....", "#....", "####.", "#....", "#....", "#...."],
    G: [".####", "#....", "#....", "#.###", "#...#", "#...#", ".####"],
    H: ["#...#", "#...#", "#...#", "#####", "#...#", "#...#", "#...#"],
    I: ["#####", "..#..", "..#..", "..#..", "..#..", "..#..", "#####"],
    J: ["..###", "...#.", "...#.", "...#.", "#..#.", "#..#.", ".##.."],
    K: ["#...#", "#..#.", "#.#..", "##...", "#.#..", "#..#.", "#...#"],
    L: ["#....", "#....", "#....", "#....", "#....", "#....", "#####"],
    M: ["#...#", "##.##", "#.#.#", "#...#", "#...#", "#...#", "#...#"],
    N: ["#...#", "##..#", "#.#.#", "#..##", "#...#", "#...#", "#...#"],
    O: [".###.", "#...#", "#...#", "#...#", "#...#", "#...#", ".###."],
    P: ["####.", "#...#", "#...#", "####.", "#....", "#....", "#...."],
    Q: [".###.", "#...#", "#...#", "#...#", "#.#.#", "#..#.", ".##.#"],
    R: ["####.", "#...#", "#...#", "####.", "#.#..", "#..#.", "#...#"],
    S: [".####", "#....", "#....", ".###.", "....#", "....#", "####."],
    T: ["#####", "..#..", "..#..", "..#..", "..#..", "..#..", "..#.."],
    U: ["#...#", "#...#", "#...#", "#...#", "#...#", "#...#", ".###."],
    V: ["#...#", "#...#", "#...#", "#...#", ".#.#.", ".#.#.", "..#.."],
    W: ["#...#", "#...#", "#...#", "#.#.#", "#.#.#", "##.##", "#...#"],
    X: ["#...#", ".#.#.", ".#.#.", "..#..", ".#.#.", ".#.#.", "#...#"],
    Y: ["#...#", ".#.#.", ".#.#.", "..#..", "..#..", "..#..", "..#.."],
    Z: ["#####", "....#", "...#.", "..#..", ".#...", "#....", "#####"],
    0: [".###.", "#...#", "#..##", "#.#.#", "##..#", "#...#", ".###."],
    1: ["..#..", ".##..", "..#..", "..#..", "..#..", "..#..", ".###."],
    2: [".###.", "#...#", "....#", "...#.", "..#..", ".#...", "#####"],
    3: ["####.", "....#", "....#", ".###.", "....#", "....#", "####."],
    4: ["#...#", "#...#", "#...#", "#####", "....#", "....#", "....#"],
    5: ["#####", "#....", "#....", "####.", "....#", "....#", "####."],
    6: [".###.", "#....", "#....", "####.", "#...#", "#...#", ".###."],
    7: ["#####", "....#", "...#.", "..#..", ".#...", ".#...", ".#..."],
    8: [".###.", "#...#", "#...#", ".###.", "#...#", "#...#", ".###."],
    9: [".###.", "#...#", "#...#", ".####", "....#", "....#", ".###."],
    ".": [".....", ".....", ".....", ".....", ".....", ".##..", ".##.."],
    ",": [".....", ".....", ".....", ".....", ".##..", ".##..", "##..."],
    ":": [".....", ".##..", ".##..", ".....", ".##..", ".##..", "....."],
    "-": [".....", ".....", ".....", "#####", ".....", ".....", "....."],
    "_": [".....", ".....", ".....", ".....", ".....", ".....", "#####"],
    "+": [".....", "..#..", "..#..", "#####", "..#..", "..#..", "....."],
    "/": ["....#", "...#.", "...#.", "..#..", ".#...", ".#...", "#...."],
    "@": [".###.", "#...#", "#.###", "#.#.#", "#.###", "#....", ".####"],
    "(": ["...#.", "..#..", ".#...", ".#...", ".#...", "..#..", "...#."],
    ")": [".#...", "..#..", "...#.", "...#.", "...#.", "..#..", ".#..."],
    "!": ["..#..", "..#..", "..#..", "..#..", "..#..", ".....", "..#.."],
    "?": [".###.", "#...#", "....#", "...#.", "..#..", ".....", "..#.."],
    "*": ["#.#.#", ".###.", "#####", ".###.", "#.#.#", ".....", "....."],
  };

  const savedPlayer = readStoredPlayer();

  let state = "start";
  let activeField = "email";
  let email = savedPlayer?.email || "";
  let instagram = savedPlayer?.instagram || "";
  let hasSavedPlayer = Boolean(savedPlayer);
  let lastTime = performance.now();
  let keys = new Set();
  let touchLeft = false;
  let touchRight = false;
  let touchFire = false;
  let fireHeld = false;
  const activePointers = new Map();
  let scorePayload = null;
  let audioContext = null;
  let soundEnabled = false;
  let flashTimer = 0;
  let shakeTimer = 0;
  let intermission = null;
  let waveSplashIndex = 0;
  let retrySplashIndex = 0;
  const leaderboardApiUrl = resolveLeaderboardApiUrl();
  let leaderboardEntries = [];
  let leaderboardStatus = leaderboardApiUrl ? "loading" : "unavailable";
  let leaderboardNotice = leaderboardApiUrl ? "LOADING" : "SCORES OFFLINE";
  let leaderboardSubmitState = "idle";
  let leaderboardLastSubmitKey = "";
  let leaderboardModalOpen = false;
  let leaderboardModalLastFocus = null;

  const player = { x: W / 2, y: 558, w: 52, h: 28, cooldown: 0 };
  const bullets = [];
  let enemies = [];
  let bonus = null;
  let score = 0;
  const STARTING_LIVES = 1;
  let lives = STARTING_LIVES;
  let wave = 1;
  let enemyDir = 1;
  let enemyStepTimer = 0;
  let bonusTimer = 0;

  const startButton = { x: 346, y: 548, w: 268, h: 54 };
  const changeDetailsButton = { x: 306, y: 616, w: 348, h: 54 };
  const startLeaderboardButton = { x: 696, y: 600, w: 230, h: 54 };
  const emailBox = { x: 286, y: 322, w: 388, h: 52 };
  const instaBox = { x: 286, y: 430, w: 388, h: 52 };
  const gameOverRestartButton = { x: 558, y: 410, w: 280, h: 54 };
  const gameOverChangeButton = { x: 514, y: 482, w: 368, h: 54 };
  const gameOverLeaderboardButton = { x: 558, y: 554, w: 280, h: 54 };

  const controls = {
    joystick: { x: 34, y: 602, w: 278, h: 104, deadzone: 28, maxOffset: 54 },
    left: { x: 34, y: 622, w: 128, h: 70 },
    right: { x: 184, y: 622, w: 128, h: 70 },
    fire: { x: 730, y: 622, w: 196, h: 70 },
  };
  const ownerSprites = {
    wave: new Image(),
    retry: new Image(),
  };
  const arcadeAssets = window.sallyArcadeAssets || {};
  const waveMessages = ["WELL DONE!", "PERFECT!", "KEEP GOING!"];
  const retryMessages = ["TRY AGAIN!", "YOU CAN DO IT!", "KEEP GOING!"];

  ownerSprites.wave.onload = draw;
  ownerSprites.retry.onload = draw;
  ownerSprites.wave.src = arcadeAssets.ownerWave || "/assets/arcade-owner-wave-v2.png";
  ownerSprites.retry.src = arcadeAssets.ownerRetry || "/assets/arcade-owner-try-again-v2.png";

  function isMobileArcade() {
    return window.matchMedia?.("(pointer: coarse) and (max-width: 680px)").matches || false;
  }

  function shouldUseMobileEntryInputs() {
    return window.matchMedia?.("(pointer: coarse)").matches || window.innerWidth <= 680;
  }

  function createMobileEntryForm() {
    const form = document.createElement("form");
    form.className = "arcade-mobile-entry-form";
    form.noValidate = true;
    form.hidden = true;
    form.setAttribute("aria-label", "Arcade entry details");

    const emailField = createMobileEntryField("email", "EMAIL");
    const instagramField = createMobileEntryField("instagram", "INSTAGRAM");
    const submit = document.createElement("button");
    submit.className = "arcade-mobile-entry-submit";
    submit.type = "submit";
    submit.textContent = "START";
    submit.disabled = true;

    const leaderboard = document.createElement("button");
    leaderboard.className = "arcade-mobile-entry-leaderboard";
    leaderboard.type = "button";
    leaderboard.textContent = "LEADERBOARD";
    leaderboard.disabled = true;
    leaderboard.tabIndex = -1;

    form.append(emailField.wrapper, instagramField.wrapper, submit, leaderboard);
    arcadeScreen?.appendChild(form);

    return {
      form,
      submit,
      leaderboard,
      fields: {
        email: emailField.input,
        instagram: instagramField.input,
      },
      wrappers: {
        email: emailField.wrapper,
        instagram: instagramField.wrapper,
      },
    };
  }

  function createLeaderboardModal() {
    const overlay = document.createElement("div");
    overlay.className = "arcade-leaderboard-modal";
    overlay.hidden = true;
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-labelledby", "arcade-leaderboard-modal-title");

    const backdrop = document.createElement("button");
    backdrop.className = "arcade-leaderboard-modal__backdrop";
    backdrop.type = "button";
    backdrop.tabIndex = -1;
    backdrop.setAttribute("aria-label", "Close leaderboard");

    const panel = document.createElement("section");
    panel.className = "arcade-leaderboard-modal__panel";

    const header = document.createElement("header");
    header.className = "arcade-leaderboard-modal__header";

    const titleWrap = document.createElement("div");
    const kicker = document.createElement("p");
    kicker.className = "arcade-leaderboard-modal__kicker";
    kicker.textContent = "TOP 10";
    const title = document.createElement("h2");
    title.className = "arcade-leaderboard-modal__title";
    title.id = "arcade-leaderboard-modal-title";
    title.textContent = "HIGH SCORES";
    titleWrap.append(kicker, title);

    const closeButton = document.createElement("button");
    closeButton.className = "arcade-leaderboard-modal__close";
    closeButton.type = "button";
    closeButton.textContent = "CLOSE";
    closeButton.setAttribute("aria-label", "Close leaderboard");

    const body = document.createElement("div");
    body.className = "arcade-leaderboard-modal__body";
    body.setAttribute("aria-live", "polite");

    const table = document.createElement("div");
    table.className = "arcade-leaderboard-modal__table";
    body.append(table);
    header.append(titleWrap, closeButton);
    panel.append(header, body);
    overlay.append(backdrop, panel);
    document.body.appendChild(overlay);

    closeButton.addEventListener("click", () => closeLeaderboardModal());
    backdrop.addEventListener("click", () => {
      if (window.matchMedia?.("(max-width: 680px)").matches) return;
      closeLeaderboardModal();
    });
    overlay.addEventListener("keydown", handleLeaderboardModalKeydown);

    return { overlay, closeButton, table };
  }

  function createMobileEntryField(field, labelText) {
    const wrapper = document.createElement("label");
    wrapper.className = `arcade-mobile-entry-field arcade-mobile-entry-field-${field}`;

    const label = document.createElement("span");
    label.className = "arcade-mobile-entry-label";
    label.textContent = labelText;

    const input = document.createElement("input");
    input.className = `arcade-mobile-entry arcade-mobile-entry-${field}`;
    input.autocomplete = field === "email" ? "email" : "off";
    input.autocapitalize = "none";
    input.autocorrect = "off";
    input.enterKeyHint = field === "email" ? "next" : "go";
    input.maxLength = field === "email" ? EMAIL_MAX_LENGTH : INSTAGRAM_MAX_LENGTH;
    input.name = `arcade-${field}`;
    input.placeholder = field === "email" ? "EMAIL" : "INSTAGRAM";
    input.required = true;
    input.spellcheck = false;
    input.disabled = true;
    input.tabIndex = -1;
    input.dataset.field = field;

    wrapper.append(label, input);
    return { wrapper, input };
  }

  function setArcadePageMode(mode) {
    document.body.classList.toggle("arcade-mode-focus", mode === "focus");
    document.body.classList.toggle("arcade-mode-play", mode === "play");
    document.body.classList.toggle("arcade-mode-attract", mode === "attract");
    document.body.classList.toggle("arcade-mobile-play", mode === "play" && isMobileArcade());
    updateMobileEntryOverlays();
    requestAnimationFrame(refreshMobileEntryOverlays);
    window.setTimeout(refreshMobileEntryOverlays, 680);
  }

  function requestArcadeFullscreen() {
    if (!isMobileArcade() || document.fullscreenElement || document.webkitFullscreenElement) return;
    const target = document.querySelector(".arcade-main") || document.documentElement;
    const request = target.requestFullscreen || target.webkitRequestFullscreen;
    if (!request) return;
    try {
      const result = request.call(target);
      if (result?.catch) result.catch(() => {});
    } catch (error) {
      // CSS immersive mode remains the fallback when fullscreen is unavailable.
    }
  }

  function scheduleAttractZoom() {
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    window.setTimeout(() => {
      if (state === "start") setArcadePageMode("focus");
    }, reduceMotion ? 120 : 850);
  }

  function sanitizeEmail(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9._+\-@]/g, "")
      .slice(0, EMAIL_MAX_LENGTH);
  }

  function sanitizeInstagram(value) {
    return String(value || "")
      .trim()
      .replace(/[^a-zA-Z0-9._@]/g, "")
      .replace(/^@+/, "")
      .slice(0, INSTAGRAM_MAX_LENGTH);
  }

  function validEmail(value = email) {
    return /^[a-z0-9._+\-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(sanitizeEmail(value));
  }

  function validInstagram(value = instagram) {
    return /^[a-zA-Z0-9._]{2,30}$/.test(sanitizeInstagram(value));
  }

  function resolveLeaderboardApiUrl() {
    const config = window.sallyArcadeLeaderboard || {};
    const apiUrl = typeof config.apiUrl === "string" ? config.apiUrl.trim() : "";
    const resolvedApiUrl = apiUrl || DEFAULT_LEADERBOARD_API_URL;
    try {
      return new URL(resolvedApiUrl, window.location.origin).toString();
    } catch (error) {
      return "";
    }
  }

  function resolveLeaderboardRegisterUrl() {
    const apiUrl = resolveLeaderboardApiUrl();
    if (!apiUrl) return "";
    try {
      return new URL("register", apiUrl.endsWith("/") ? apiUrl : `${apiUrl}/`).toString();
    } catch (error) {
      return "";
    }
  }

  async function registerPlayer(details) {
    const registerUrl = resolveLeaderboardRegisterUrl();
    if (!registerUrl || !details) return;

    try {
      await fetch(registerUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: details.email,
          instagram: details.instagram,
        }),
        credentials: "omit",
      });
    } catch (error) {
      // Registration should never block gameplay.
    }
  }

  function normalizeLeaderboardEntries(entries) {
    if (!Array.isArray(entries)) return [];
    return entries
      .slice(0, LEADERBOARD_LIMIT)
      .map((entry, index) => {
        const handle = sanitizeInstagram(entry?.handle);
        const scoreValue = Number(entry?.score);
        const waveValue = Number(entry?.wave);
        return {
          rank: Number.isInteger(Number(entry?.rank)) ? Number(entry.rank) : index + 1,
          handle: handle ? `@${handle}` : "@PLAYER",
          score: Number.isFinite(scoreValue) ? Math.max(0, Math.round(scoreValue)) : 0,
          wave: Number.isInteger(waveValue) && waveValue > 0 ? waveValue : 1,
          updatedAt: typeof entry?.updatedAt === "string" ? entry.updatedAt : "",
        };
      })
      .filter((entry) => entry.score >= 0);
  }

  async function refreshLeaderboard({ quiet = false } = {}) {
    if (!leaderboardApiUrl) return;
    if (!quiet) {
      leaderboardStatus = "loading";
      leaderboardNotice = "LOADING";
      draw();
    }
    try {
      const response = await fetch(leaderboardApiUrl, {
        method: "GET",
        headers: { Accept: "application/json" },
        cache: "no-store",
        credentials: "omit",
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload?.error || "Leaderboard unavailable");
      leaderboardEntries = normalizeLeaderboardEntries(payload.entries);
      leaderboardStatus = "ready";
      leaderboardNotice = leaderboardEntries.length ? "" : "BE FIRST";
    } catch (error) {
      leaderboardStatus = "error";
      leaderboardNotice = "SCORES OFFLINE";
    }
    if (leaderboardModalOpen) renderLeaderboardModal();
    draw();
  }

  async function submitLeaderboardScore(payload) {
    if (!leaderboardApiUrl || !payload) return;
    const submitKey = `${payload.email}:${payload.instagram}:${payload.score}:${payload.wave}`;
    if (leaderboardLastSubmitKey === submitKey) return;
    leaderboardLastSubmitKey = submitKey;
    leaderboardSubmitState = "submitting";
    leaderboardNotice = "SENDING SCORE";
    draw();

    try {
      const response = await fetch(leaderboardApiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: payload.email,
          instagram: payload.instagram,
          score: payload.score,
          wave: payload.wave,
        }),
        credentials: "omit",
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result?.error || "Leaderboard unavailable");
      leaderboardEntries = normalizeLeaderboardEntries(result.entries);
      leaderboardStatus = "ready";
      leaderboardSubmitState = result.accepted ? "posted" : "kept";
      leaderboardNotice = result.accepted ? "SCORE POSTED" : "BEST SCORE KEPT";
    } catch (error) {
      leaderboardSubmitState = "error";
      leaderboardNotice = "SCORE NOT SENT";
      refreshLeaderboard({ quiet: true });
      return;
    }
    if (leaderboardModalOpen) renderLeaderboardModal();
    draw();
  }

  function leaderboardStatusCopy() {
    if (leaderboardStatus === "ready") return leaderboardEntries.length ? "" : "BE FIRST";
    return leaderboardNotice || "SCORES OFFLINE";
  }

  function renderLeaderboardModal() {
    if (!leaderboardModal) return;
    const table = leaderboardModal.table;
    table.replaceChildren();

    if (leaderboardStatus !== "ready" || leaderboardEntries.length === 0) {
      const status = document.createElement("p");
      status.className = "arcade-leaderboard-modal__status";
      status.textContent = leaderboardStatusCopy();
      table.append(status);
      return;
    }

    const heading = document.createElement("div");
    heading.className = "arcade-leaderboard-modal__heading";
    for (const label of ["RK", "PLAYER", "SCORE", "WAVE"]) {
      const item = document.createElement("span");
      item.textContent = label;
      heading.append(item);
    }
    table.append(heading);

    leaderboardEntries.slice(0, LEADERBOARD_LIMIT).forEach((entry, index) => {
      const row = document.createElement("div");
      row.className = "arcade-leaderboard-modal__row";
      if (index === 0) row.classList.add("is-top-score");

      const rank = document.createElement("span");
      rank.className = "arcade-leaderboard-modal__rank";
      rank.textContent = String(entry.rank || index + 1).padStart(2, "0");

      const handle = document.createElement("span");
      handle.className = "arcade-leaderboard-modal__handle";
      handle.textContent = entry.handle || "@PLAYER";

      const scoreCell = document.createElement("span");
      scoreCell.className = "arcade-leaderboard-modal__score";
      scoreCell.textContent = String(entry.score);

      const waveCell = document.createElement("span");
      waveCell.className = "arcade-leaderboard-modal__wave";
      waveCell.textContent = String(entry.wave || 1);

      row.append(rank, handle, scoreCell, waveCell);
      table.append(row);
    });
  }

  function openLeaderboardModal({ source = null } = {}) {
    if (!leaderboardModal || leaderboardModalOpen) return;
    leaderboardModalLastFocus = source || document.activeElement || canvas;
    leaderboardModalOpen = true;
    renderLeaderboardModal();
    leaderboardModal.overlay.hidden = false;
    leaderboardModal.overlay.classList.add("is-active");
    document.body.classList.add("arcade-leaderboard-modal-open");
    resetTouchControls();
    fireHeld = false;
    leaderboardModal.table.parentElement.scrollTop = 0;
    if (leaderboardApiUrl && leaderboardStatus !== "loading") refreshLeaderboard({ quiet: true });
    requestAnimationFrame(() => {
      try {
        leaderboardModal.closeButton.focus({ preventScroll: true });
      } catch (error) {
        leaderboardModal.closeButton.focus();
      }
    });
  }

  function closeLeaderboardModal({ restoreFocus = true } = {}) {
    if (!leaderboardModalOpen || !leaderboardModal) return;
    leaderboardModalOpen = false;
    leaderboardModal.overlay.classList.remove("is-active");
    leaderboardModal.overlay.hidden = true;
    document.body.classList.remove("arcade-leaderboard-modal-open");
    if (!restoreFocus) return;
    const focusTarget = leaderboardModalLastFocus || canvas;
    leaderboardModalLastFocus = null;
    try {
      focusTarget.focus({ preventScroll: true });
    } catch (error) {
      focusTarget.focus?.();
    }
  }

  function handleLeaderboardModalKeydown(event) {
    if (!leaderboardModalOpen) return;
    if (event.key === "Escape") {
      event.preventDefault();
      closeLeaderboardModal();
      return;
    }
    if (event.key !== "Tab") return;

    const focusable = Array.from(leaderboardModal.overlay.querySelectorAll("button:not([disabled]):not([tabindex='-1'])"));
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function normalizePlayerDetails(details) {
    if (!details || typeof details !== "object") return null;
    const normalized = {
      email: sanitizeEmail(details.email),
      instagram: sanitizeInstagram(details.instagram),
    };
    return validEmail(normalized.email) && validInstagram(normalized.instagram) ? normalized : null;
  }

  function readStoredPlayer() {
    try {
      const raw = window.localStorage?.getItem(PLAYER_STORAGE_KEY);
      if (!raw) return normalizePlayerDetails(memoryStoredPlayer);
      return normalizePlayerDetails(JSON.parse(raw));
    } catch (error) {
      return normalizePlayerDetails(memoryStoredPlayer);
    }
  }

  function writeStoredPlayer(details) {
    const normalized = normalizePlayerDetails(details);
    if (!normalized) return false;
    memoryStoredPlayer = normalized;
    try {
      window.localStorage?.setItem(PLAYER_STORAGE_KEY, JSON.stringify(normalized));
    } catch (error) {
      // The in-memory copy keeps the current arcade session playable when storage is blocked.
    }
    return true;
  }

  function clearStoredPlayer() {
    memoryStoredPlayer = null;
    try {
      window.localStorage?.removeItem(PLAYER_STORAGE_KEY);
    } catch (error) {
      // Ignore unavailable storage; clearing the in-memory copy is enough for this session.
    }
  }

  function validEntry() {
    return validEmail() && validInstagram();
  }

  function fieldValue(field) {
    return field === "email" ? email : instagram;
  }

  function mobileEntryInputIsFocused() {
    return mobileEntryInputs.includes(document.activeElement);
  }

  function refreshMobileEntryOverlays() {
    if (!mobileEntryInputIsFocused()) updateMobileEntryOverlays();
  }

  function syncMobileEntryInput(field = activeField, forceValue = false) {
    const input = mobileEntryFields[field];
    if (!input) return;
    input.type = field === "email" ? "email" : "text";
    input.inputMode = field === "email" ? "email" : "text";
    input.setAttribute("aria-label", field === "email" ? "Email" : "Instagram");
    if (forceValue || document.activeElement !== input) input.value = fieldValue(field);
  }

  function overlayRectStyle(rect, { padX = 0, padY = 0 } = {}) {
    const left = Math.max(0, rect.x - padX);
    const top = Math.max(0, rect.y - padY);
    const right = Math.min(W, rect.x + rect.w + padX);
    const bottom = Math.min(H, rect.y + rect.h + padY);
    return {
      left: `${(left / W) * 100}%`,
      top: `${(top / H) * 100}%`,
      width: `${((right - left) / W) * 100}%`,
      height: `${((bottom - top) / H) * 100}%`,
    };
  }

  function applyOverlayRect(element, rect, options) {
    if (!element) return;
    Object.assign(element.style, overlayRectStyle(rect, options));
  }

  function positionMobileEntryOverlays() {
    applyOverlayRect(mobileEntryWrappers.email, emailBox, { padX: 18, padY: 24 });
    applyOverlayRect(mobileEntryWrappers.instagram, instaBox, { padX: 18, padY: 24 });
    applyOverlayRect(mobileEntrySubmit, startButton, { padX: 16, padY: 18 });
    applyOverlayRect(mobileEntryLeaderboard, startLeaderboardButton, { padX: 16, padY: 18 });
  }

  function updateMobileEntryOverlays(forceValue = false) {
    const enabled = state === "start" && shouldUseMobileEntryInputs() && !hasSavedPlayer;
    if (enabled && mobileEntryInputIsFocused() && !forceValue) {
      mobileEntrySubmit.disabled = !validEntry();
      return;
    }
    document.body.classList.toggle("arcade-mobile-entry-active", enabled);
    mobileEntryForm.hidden = !enabled;
    mobileEntryForm.classList.toggle("is-active", enabled);
    if (enabled) positionMobileEntryOverlays();
    for (const [field, input] of Object.entries(mobileEntryFields)) {
      syncMobileEntryInput(field, forceValue);
      input.disabled = !enabled;
      input.tabIndex = enabled ? 0 : -1;
    }
    mobileEntrySubmit.disabled = !enabled || !validEntry();
    mobileEntryLeaderboard.disabled = !enabled;
    mobileEntryLeaderboard.tabIndex = enabled ? 0 : -1;
    if (!enabled && (mobileEntryInputs.includes(document.activeElement) || document.activeElement === mobileEntryLeaderboard)) {
      document.activeElement.blur();
    }
  }

  function focusMobileEntryInput({ selectText = false } = {}) {
    if (!shouldUseMobileEntryInputs()) {
      canvas.focus();
      return;
    }
    updateMobileEntryOverlays(true);
    const input = mobileEntryFields[activeField];
    syncMobileEntryInput(activeField, true);
    input.disabled = false;
    input.tabIndex = 0;
    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      input.focus();
    }
    if (selectText && input.value) {
      try {
        input.select();
      } catch (error) {
        // Some mobile browsers reject select() during touch focus.
      }
    }
  }

  function resetGame() {
    score = 0;
    lives = STARTING_LIVES;
    wave = 1;
    intermission = null;
    leaderboardSubmitState = "idle";
    leaderboardLastSubmitKey = "";
    player.x = W / 2;
    player.cooldown = 0;
    fireHeld = false;
    resetTouchControls();
    bullets.length = 0;
    bonus = null;
    bonusTimer = 0;
    createWave();
  }

  function persistCurrentPlayer() {
    const normalized = normalizePlayerDetails({ email, instagram });
    if (!normalized || !writeStoredPlayer(normalized)) return false;
    email = normalized.email;
    instagram = normalized.instagram;
    hasSavedPlayer = true;
    return true;
  }

  function changePlayerDetails({ focus = true } = {}) {
    clearStoredPlayer();
    hasSavedPlayer = false;
    email = "";
    instagram = "";
    activeField = "email";
    scorePayload = null;
    resetTouchControls();
    mobileEntryInputs.forEach((input) => input.blur());
    state = "start";
    setArcadePageMode("focus");
    updateMobileEntryOverlays(true);
    draw();
    if (focus) focusMobileEntryInput({ selectText: true });
  }

  function createWave() {
    enemies = [];
    enemyDir = 1;
    const types = ["cap", "tee", "hoodie", "asterisk"];
    for (let row = 0; row < 4; row++) {
      for (let col = 0; col < 9; col++) {
        enemies.push({
          x: 128 + col * 78,
          y: 112 + row * 58,
          w: 46,
          h: 36,
          type: types[(row + col) % types.length],
          alive: true,
        });
      }
    }
  }

  function beginGame() {
    if (!validEntry()) return;
    if (!persistCurrentPlayer()) return;
    registerPlayer({
      email,
      instagram: instagram.startsWith("@") ? instagram : `@${instagram}`,
    });
    requestArcadeFullscreen();
    mobileEntryInputs.forEach((input) => input.blur());
    mobileEntryForm.hidden = true;
    initAudio();
    playSound("start");
    resetGame();
    state = "playing";
    setArcadePageMode("play");
    canvas.focus();
  }

  function initAudio() {
    if (!audioContext) {
      const AudioCtor = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtor) return;
      audioContext = new AudioCtor();
    }
    if (audioContext.state === "suspended") audioContext.resume();
    soundEnabled = true;
  }

  function playTone(freq, duration, type = "square", volume = 0.045, delay = 0) {
    if (!audioContext || !soundEnabled) return;
    const now = audioContext.currentTime + delay;
    const osc = audioContext.createOscillator();
    const gain = audioContext.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, now);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(volume, now + 0.006);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    osc.connect(gain);
    gain.connect(audioContext.destination);
    osc.start(now);
    osc.stop(now + duration + 0.01);
  }

  function playNoise(duration, volume = 0.04) {
    if (!audioContext || !soundEnabled) return;
    const samples = Math.floor(audioContext.sampleRate * duration);
    const buffer = audioContext.createBuffer(1, samples, audioContext.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < samples; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / samples);
    const source = audioContext.createBufferSource();
    const gain = audioContext.createGain();
    source.buffer = buffer;
    gain.gain.value = volume;
    source.connect(gain);
    gain.connect(audioContext.destination);
    source.start();
  }

  function playSound(name) {
    if (name === "start") {
      playTone(220, 0.08, "square", 0.05);
      playTone(440, 0.08, "square", 0.05, 0.08);
      playTone(880, 0.12, "square", 0.045, 0.16);
    }
    if (name === "shoot") playTone(720, 0.055, "square", 0.035);
    if (name === "hit") {
      playTone(280, 0.045, "square", 0.04);
      playTone(140, 0.06, "square", 0.025, 0.035);
    }
    if (name === "bonus") {
      playTone(660, 0.08, "square", 0.045);
      playTone(990, 0.12, "square", 0.04, 0.08);
    }
    if (name === "wave") {
      playTone(330, 0.06, "square", 0.04);
      playTone(494, 0.06, "square", 0.04, 0.07);
      playTone(659, 0.1, "square", 0.04, 0.14);
    }
    if (name === "waveSplash") {
      playTone(392, 0.08, "square", 0.042);
      playTone(523, 0.08, "square", 0.042, 0.08);
      playTone(659, 0.1, "square", 0.04, 0.16);
      playTone(784, 0.1, "square", 0.038, 0.28);
      playTone(988, 0.12, "square", 0.034, 0.4);
      playTone(784, 0.08, "square", 0.032, 0.54);
      playTone(988, 0.18, "square", 0.032, 0.64);
    }
    if (name === "damage") {
      playNoise(0.16, 0.045);
      playTone(98, 0.16, "sawtooth", 0.035);
    }
    if (name === "retrySplash") {
      playTone(196, 0.08, "triangle", 0.038);
      playTone(147, 0.08, "square", 0.032, 0.09);
      playTone(220, 0.14, "square", 0.035, 0.2);
      playTone(262, 0.08, "square", 0.03, 0.38);
      playTone(330, 0.16, "square", 0.03, 0.5);
    }
    if (name === "gameover") {
      playNoise(0.12, 0.03);
      playTone(330, 0.1, "triangle", 0.042);
      playTone(294, 0.1, "square", 0.038, 0.12);
      playTone(247, 0.12, "triangle", 0.038, 0.24);
      playTone(196, 0.14, "square", 0.034, 0.38);
      playTone(147, 0.18, "triangle", 0.032, 0.56);
      playTone(98, 0.28, "triangle", 0.03, 0.76);
    }
  }

  function buildScorePayload() {
    return {
      email,
      instagram: instagram.startsWith("@") ? instagram : `@${instagram}`,
      score,
      wave,
      createdAt: new Date().toISOString(),
    };
  }

  // Future hook: render and export a branded high-score card from this payload.
  function createShareCardPayload() {
    return scorePayload;
  }

  function rectHit(a, b) {
    return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
  }

  function pointInRect(point, rect) {
    return point.x >= rect.x && point.x <= rect.x + rect.w && point.y >= rect.y && point.y <= rect.y + rect.h;
  }

  function joystickDirection(point) {
    const stick = controls.joystick;
    if (!pointInRect(point, stick)) return 0;
    const offset = point.x - (stick.x + stick.w / 2);
    if (Math.abs(offset) < stick.deadzone) return 0;
    return offset < 0 ? -1 : 1;
  }

  function getTouchZones(point) {
    if (shouldUseMobileEntryInputs()) {
      const joystick = joystickDirection(point);
      return {
        left: joystick < 0,
        right: joystick > 0,
        fire: pointInRect(point, controls.fire),
        joystick,
      };
    }

    return {
      left: pointInRect(point, controls.left),
      right: pointInRect(point, controls.right),
      fire: pointInRect(point, controls.fire),
      joystick: 0,
    };
  }

  function syncTouchControls() {
    touchLeft = false;
    touchRight = false;
    touchFire = false;
    for (const zones of activePointers.values()) {
      touchLeft = touchLeft || zones.left;
      touchRight = touchRight || zones.right;
      touchFire = touchFire || zones.fire;
    }
  }

  function resetTouchControls() {
    activePointers.clear();
    touchLeft = false;
    touchRight = false;
    touchFire = false;
  }

  function pointerPosition(event) {
    const rect = canvas.getBoundingClientRect();
    return {
      x: ((event.clientX - rect.left) / rect.width) * W,
      y: ((event.clientY - rect.top) / rect.height) * H,
    };
  }

  function shoot() {
    if (state !== "playing") return;
    if (player.cooldown > 0) return;
    bullets.push({ x: player.x - 3, y: player.y - 26, w: 6, h: 18, speed: 560 });
    player.cooldown = 0.38;
    playSound("shoot");
  }

  function startIntermission(kind) {
    resetTouchControls();
    fireHeld = false;
    bullets.length = 0;
    bonus = null;
    state = "intermission";

    if (kind === "wave") {
      intermission = {
        kind,
        timer: 5.6,
        duration: 5.6,
        message: waveMessages[waveSplashIndex % waveMessages.length],
      };
      waveSplashIndex += 1;
      playSound("waveSplash");
      return;
    }

    intermission = {
      kind: "retry",
      timer: 4.8,
      duration: 4.8,
      message: retryMessages[retrySplashIndex % retryMessages.length],
    };
    retrySplashIndex += 1;
    playSound("retrySplash");
  }

  function update(dt) {
    flashTimer = Math.max(0, flashTimer - dt);
    shakeTimer = Math.max(0, shakeTimer - dt);
    if (state === "intermission") {
      if (intermission) intermission.timer -= dt;
      if (!intermission || intermission.timer <= 0) {
        createWave();
        intermission = null;
        state = "playing";
      }
      return;
    }
    if (state !== "playing") return;

    const movingLeft = keys.has("ArrowLeft") || keys.has("a") || keys.has("A") || touchLeft;
    const movingRight = keys.has("ArrowRight") || keys.has("d") || keys.has("D") || touchRight;
    if (movingLeft) player.x -= 390 * dt;
    if (movingRight) player.x += 390 * dt;
    player.x = Math.max(34, Math.min(W - 34, player.x));

    player.cooldown = Math.max(0, player.cooldown - dt);

    for (const bullet of bullets) bullet.y -= bullet.speed * dt;
    for (let i = bullets.length - 1; i >= 0; i--) {
      if (bullets[i].y < -24) bullets.splice(i, 1);
    }

    const enemySpeed = (34 + wave * 8) * 1.5;
    enemyStepTimer += dt;
    let hitEdge = false;
    for (const enemy of enemies) {
      enemy.x += enemyDir * enemySpeed * dt;
      if (enemy.x < 26 || enemy.x + enemy.w > W - 26) hitEdge = true;
    }
    if (hitEdge && enemyStepTimer > 0.18) {
      enemyDir *= -1;
      enemyStepTimer = 0;
      for (const enemy of enemies) enemy.y += 24;
    }

    for (let b = bullets.length - 1; b >= 0; b--) {
      const bullet = bullets[b];
      let removed = false;
      for (let e = enemies.length - 1; e >= 0; e--) {
        const enemy = enemies[e];
        if (rectHit(bullet, enemy)) {
          score += enemy.type === "asterisk" ? 80 : 40;
          flashTimer = 0.07;
          playSound("hit");
          enemies.splice(e, 1);
          bullets.splice(b, 1);
          removed = true;
          break;
        }
      }
      if (!removed && bonus && rectHit(bullet, bonus)) {
        score += 250;
        flashTimer = 0.12;
        playSound("bonus");
        bonus = null;
        bullets.splice(b, 1);
      }
    }

    if (enemies.some((enemy) => enemy.y + enemy.h > player.y - 38)) {
      lives -= 1;
      shakeTimer = 0.3;
      flashTimer = 0.18;
      playSound("damage");
      bullets.length = 0;
      if (lives <= 0) {
        scorePayload = buildScorePayload();
        createShareCardPayload();
        state = "gameover";
        submitLeaderboardScore(scorePayload);
        playSound("gameover");
      } else {
        startIntermission("retry");
      }
      return;
    }

    if (enemies.length === 0) {
      wave += 1;
      startIntermission("wave");
      return;
    }

    bonusTimer += dt;
    if (!bonus && bonusTimer > Math.max(4, 9 - wave * 0.4)) {
      bonus = { x: -72, y: 74, w: 46, h: 42, speed: 170 + wave * 12 };
      bonusTimer = 0;
    }
    if (bonus) {
      bonus.x += bonus.speed * dt;
      if (bonus.x > W + 80) bonus = null;
    }
  }

  function measurePixelText(text, scale, tracking) {
    const chars = String(text).toUpperCase().split("");
    return chars.reduce((width, char, index) => {
      const glyph = pixelFont[char] || pixelFont["?"];
      return width + glyph[0].length * scale + (index < chars.length - 1 ? tracking : 0);
    }, 0);
  }

  function drawPixelText(text, x, y, scale, color, align = "left", tracking = scale, weight = 1) {
    const chars = String(text).toUpperCase().split("");
    const width = measurePixelText(text, scale, tracking);
    let cursor = align === "center" ? x - width / 2 : align === "right" ? x - width : x;
    const strokeWidth = Math.max(scale, scale * weight);

    ctx.fillStyle = color;
    chars.forEach((char) => {
      const glyph = pixelFont[char] || pixelFont["?"];
      for (let row = 0; row < glyph.length; row++) {
        for (let col = 0; col < glyph[row].length; col++) {
          if (glyph[row][col] === ".") continue;
          ctx.fillRect(Math.round(cursor + col * scale), Math.round(y + row * scale), strokeWidth, scale);
        }
      }
      cursor += glyph[0].length * scale + tracking;
    });
  }

  function drawText(text, x, y, size, color = colors.paper, align = "left", display = false, weight = 1) {
    const scale = Math.max(1, Math.round(size / 7));
    const tracking = display ? scale * 2 : scale;
    const top = Math.round(y - 7 * scale);

    if (display) drawPixelText(text, x + scale, top + scale, scale, "rgba(0, 0, 0, 0.72)", align, tracking, weight);
    drawPixelText(text, x, top, scale, color, align, tracking, weight);
  }

  function fitDisplayText(text, size, maxWidth) {
    const value = String(text || "");
    const scale = Math.max(1, Math.round(size / 7));
    const tracking = scale;
    if (measurePixelText(value, scale, tracking) <= maxWidth) return value;
    const suffix = "...";
    let clipped = value;
    while (clipped.length > 0 && measurePixelText(`${clipped}${suffix}`, scale, tracking) > maxWidth) {
      clipped = clipped.slice(0, -1);
    }
    return clipped ? `${clipped}${suffix}` : suffix;
  }

  function drawField(label, value, rect, active) {
    const displayValue = fitDisplayText(value, 22, rect.w - 36);
    ctx.strokeStyle = active ? colors.red : colors.beige;
    ctx.lineWidth = active ? 3 : 1;
    ctx.strokeRect(rect.x, rect.y, rect.w, rect.h);
    drawText(label, rect.x, rect.y - 14, 13, colors.muted);
    drawText(displayValue, rect.x + 18, rect.y + 34, 22, colors.paper);
    if (active && Math.floor(performance.now() / 520) % 2 === 0) {
      const scale = Math.max(1, Math.round(22 / 7));
      const textWidth = displayValue ? measurePixelText(displayValue, scale, scale) : 0;
      const cursorX = Math.min(rect.x + rect.w - 22, rect.x + 18 + textWidth + scale * 2);
      const cursorY = Math.round(rect.y + 34 - 7 * scale);
      ctx.fillStyle = colors.red;
      ctx.fillRect(cursorX, cursorY, scale, 7 * scale);
    }
  }

  function drawButton(rect, label, enabled = true) {
    ctx.fillStyle = enabled ? colors.red : "#2a2a2a";
    ctx.strokeStyle = enabled ? colors.red : colors.muted;
    ctx.lineWidth = 2;
    ctx.fillRect(rect.x, rect.y, rect.w, rect.h);
    ctx.strokeRect(rect.x, rect.y, rect.w, rect.h);
    drawText(label, rect.x + rect.w / 2, rect.y + 35, 16, enabled ? colors.paper : colors.muted, "center");
  }

  function drawPortraitCard(image, x = 66, y = 140, size = 420) {
    const card = { x, y, w: size, h: size };

    if (image.complete && image.naturalWidth) {
      ctx.drawImage(image, card.x, card.y, card.w, card.h);
      return;
    }

    ctx.fillStyle = "rgba(216, 204, 182, 0.08)";
    ctx.fillRect(card.x, card.y, card.w, card.h);
    drawText("LOADING", card.x + card.w / 2, card.y + card.h / 2, 18, colors.muted, "center");
  }

  function pixelSprite(x, y, scale, rows, palette) {
    for (let r = 0; r < rows.length; r++) {
      for (let c = 0; c < rows[r].length; c++) {
        const color = palette[rows[r][c]];
        if (!color) continue;
        ctx.fillStyle = color;
        ctx.fillRect(Math.round(x + c * scale), Math.round(y + r * scale), scale, scale);
      }
    }
  }

  function drawCap(x, y) {
    pixelSprite(x, y + 2, 5, [
      "..WWWW..",
      ".WBBBBW.",
      "WBBBBBBW",
      "WBRRRRBW",
      ".BBBBBB.",
      "WWWWWWWW",
      "..WWWW..",
    ], { W: colors.paper, B: "#050505", R: colors.red });
  }

  function drawTee(x, y) {
    pixelSprite(x + 1, y, 5, [
      "..WWWW..",
      ".WBBBBW.",
      "WWBBBBWW",
      "W.BBB.BW",
      "..BBBB..",
      "..BRB...",
      "..BBBB..",
      "..BBBB..",
    ], { W: colors.beige, B: "#050505", R: colors.red });
  }

  function drawHoodie(x, y) {
    pixelSprite(x + 3, y, 5, [
      "..WW..",
      ".WBBW.",
      "WBBBBW",
      "WBRRBW",
      "WBBBBW",
      "WBBBBW",
      ".WWWW.",
    ], { W: colors.paper, B: "#050505", R: colors.red });
  }

  function drawEnemy(enemy) {
    if (enemy.type === "cap") drawCap(enemy.x, enemy.y);
    if (enemy.type === "tee") drawTee(enemy.x, enemy.y);
    if (enemy.type === "hoodie") drawHoodie(enemy.x, enemy.y);
    if (enemy.type === "asterisk") drawText("*", enemy.x + 22, enemy.y + 43, 54, colors.red, "center", true);
  }

  function drawPlayer() {
    pixelSprite(player.x - 36, player.y - 28, 6, [
      ".....W.....",
      "....WWW....",
      "...WWRWW...",
      "..WWRRRWW..",
      ".WWWWWWWWW.",
      "WWWRRRRRWWW",
      "...WWWWW...",
      "..WW...WW..",
    ], { W: colors.paper, R: colors.red });
  }

  function drawHud() {
    drawText(`SCORE ${score}`, 28, 34, 15, colors.paper);
    drawText(`WAVE ${wave}`, W / 2, 34, 15, colors.paper, "center");
    drawText(`${lives === 1 ? "LIFE" : "LIVES"} ${lives}`, W - 28, 34, 15, colors.paper, "right");
    drawText(soundEnabled ? "SOUND ON / M" : "SOUND OFF / M", W - 28, 58, 12, colors.muted, "right");
  }

  function drawControls() {
    if (shouldUseMobileEntryInputs()) {
      drawJoystick(touchLeft ? -1 : touchRight ? 1 : 0);
    } else {
      drawControlButton(controls.left, "left", touchLeft);
      drawControlButton(controls.right, "right", touchRight);
    }
    drawControlButton(controls.fire, "shoot", touchFire);
  }

  function drawJoystick(direction) {
    const stick = controls.joystick;
    const centerX = stick.x + stick.w / 2;
    const centerY = stick.y + stick.h / 2;
    const knobX = centerX + direction * stick.maxOffset;
    const active = direction !== 0;

    ctx.fillStyle = active ? "rgba(184, 58, 46, 0.2)" : "rgba(216, 204, 182, 0.06)";
    ctx.strokeStyle = active ? colors.red : colors.muted;
    ctx.lineWidth = active ? 3 : 2;
    ctx.beginPath();
    ctx.ellipse(centerX, centerY, 92, 42, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();

    ctx.strokeStyle = active ? colors.red : colors.muted;
    ctx.lineWidth = 6;
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.lineTo(knobX, centerY);
    ctx.stroke();

    ctx.fillStyle = active ? colors.red : colors.beige;
    ctx.strokeStyle = colors.muted;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(knobX, centerY, 25, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();

    drawText("MOVE", centerX, stick.y + 18, 13, active ? colors.red : colors.beige, "center");
  }

  function drawControlButton(rect, type, active) {
    ctx.fillStyle = active ? "rgba(184, 58, 46, 0.34)" : "rgba(216, 204, 182, 0.06)";
    ctx.strokeStyle = active ? colors.red : colors.muted;
    ctx.lineWidth = active ? 3 : 2;
    ctx.fillRect(rect.x, rect.y, rect.w, rect.h);
    ctx.strokeRect(rect.x, rect.y, rect.w, rect.h);

    if (type === "left") {
      pixelSprite(rect.x + 42, rect.y + 18, 7, [
        "...W.",
        "..WW.",
        ".WWW.",
        "WWWW.",
        ".WWW.",
        "..WW.",
        "...W.",
      ], { W: active ? colors.red : colors.beige });
      return;
    }

    if (type === "right") {
      pixelSprite(rect.x + 42, rect.y + 18, 7, [
        ".W...",
        ".WW..",
        ".WWW.",
        ".WWWW",
        ".WWW.",
        ".WW..",
        ".W...",
      ], { W: active ? colors.red : colors.beige });
      return;
    }

    drawText("SHOOT", rect.x + rect.w / 2, rect.y + 32, 18, active ? colors.red : colors.beige, "center");
    ctx.fillStyle = active ? colors.red : colors.muted;
    ctx.fillRect(rect.x + rect.w / 2 - 4, rect.y + 44, 8, 14);
  }

  function drawLeaderboard(rect, { compact = false } = {}) {
    ctx.fillStyle = "rgba(5, 5, 5, 0.72)";
    ctx.fillRect(rect.x, rect.y, rect.w, rect.h);
    ctx.strokeStyle = "rgba(216, 204, 182, 0.42)";
    ctx.lineWidth = 2;
    ctx.strokeRect(rect.x, rect.y, rect.w, rect.h);

    drawText("HIGH SCORES", rect.x + rect.w / 2, rect.y + 32, compact ? 12 : 15, colors.red, "center");

    if (leaderboardStatus !== "ready" || leaderboardEntries.length === 0) {
      const copy = leaderboardNotice || (leaderboardStatus === "ready" ? "BE FIRST" : "SCORES OFFLINE");
      drawText(copy, rect.x + rect.w / 2, rect.y + rect.h / 2 + 6, compact ? 10 : 13, colors.beige, "center");
      return;
    }

    const rowHeight = compact ? 20 : 22;
    const scoreWidth = compact ? 72 : 86;
    const firstRowY = rect.y + (compact ? 60 : 64);
    const maxRows = Math.min(LEADERBOARD_LIMIT, leaderboardEntries.length, Math.floor((rect.h - 58) / rowHeight));

    for (let index = 0; index < maxRows; index++) {
      const entry = leaderboardEntries[index];
      const y = firstRowY + index * rowHeight;
      const rank = String(entry.rank || index + 1).padStart(2, "0");
      const handleMaxWidth = rect.w - scoreWidth - 74;
      const handle = fitDisplayText(entry.handle, compact ? 10 : 11, handleMaxWidth);
      const color = index === 0 ? colors.red : colors.paper;

      drawText(rank, rect.x + 16, y, compact ? 10 : 11, colors.muted);
      drawText(handle, rect.x + 54, y, compact ? 10 : 11, color);
      drawText(String(entry.score), rect.x + rect.w - 14, y, compact ? 10 : 11, colors.beige, "right");
    }
  }

  function leaderboardSubmitCopy() {
    if (leaderboardSubmitState === "submitting") return "SENDING SCORE";
    if (leaderboardSubmitState === "posted") return "SCORE POSTED";
    if (leaderboardSubmitState === "kept") return "BEST SCORE KEPT";
    if (leaderboardSubmitState === "error") return "SCORE NOT SENT";
    return leaderboardNotice || "BETTER LUCK";
  }

  function drawStart() {
    const showActiveEntryField = !hasSavedPlayer && !shouldUseMobileEntryInputs();
    drawText("SALLY", W / 2, 136, 78, colors.red, "center", true, 2);
    drawText("ARCADE", W / 2, 222, 78, colors.paper, "center", true, 2);
    drawText(hasSavedPlayer ? "PLAYER READY" : "ENTER DETAILS TO PLAY", W / 2, 274, 15, colors.beige, "center");
    drawField("EMAIL", email, emailBox, showActiveEntryField && activeField === "email");
    drawField("INSTAGRAM", instagram ? `@${instagram.replace(/^@/, "")}` : "", instaBox, showActiveEntryField && activeField === "instagram");
    const ready = validEntry();
    drawButton(startButton, ready && isMobileArcade() ? "PLAY FULLSCREEN" : "START", ready);
    if (hasSavedPlayer) {
      drawButton(changeDetailsButton, "CHANGE DETAILS", true);
      drawText("ENTER START / C CHANGE", W / 2, 694, 12, colors.muted, "center");
    } else {
      drawText("TAB TO SWITCH / ENTER TO START", W / 2, 632, 13, colors.muted, "center");
      drawText("A/D OR ARROWS + SPACE AFTER START", W / 2, 658, 12, colors.muted, "center");
    }
    drawLeaderboard({ x: 696, y: 310, w: 230, h: 276 }, { compact: true });
    drawButton(startLeaderboardButton, "LEADERBOARD", true);
  }

  function drawGameOver() {
    ctx.fillStyle = "rgba(5, 5, 5, 0.62)";
    ctx.fillRect(0, 0, W, H);
    drawPortraitCard(ownerSprites.retry, 82, 106, 210);
    drawLeaderboard({ x: 44, y: 346, w: 390, h: 318 });
    drawText("GAME OVER", 700, 160, 54, colors.red, "center", true);
    drawText(`FINAL SCORE ${score}`, 700, 244, 22, colors.paper, "center");
    drawText(fitDisplayText(`${instagram.startsWith("@") ? instagram : `@${instagram}`}`, 18, 310), 700, 290, 18, colors.beige, "center");
    drawText(fitDisplayText(email, 12, 310), 700, 318, 12, colors.muted, "center");
    drawText(leaderboardSubmitCopy(), 700, 358, 14, colors.muted, "center");
    drawText("NEXT TIME!", 700, 382, 16, colors.muted, "center");
    drawButton(gameOverRestartButton, "RESTART", true);
    drawButton(gameOverChangeButton, "CHANGE DETAILS", true);
    drawButton(gameOverLeaderboardButton, "LEADERBOARD", true);
  }

  function drawIntermission() {
    if (!intermission) return;
    const isWave = intermission.kind === "wave";
    const image = isWave ? ownerSprites.wave : ownerSprites.retry;
    const lifeCopy = lives === 1 ? "LIFE 1 LEFT" : `LIVES ${lives} LEFT`;
    const kicker = isWave ? `WAVE ${wave - 1} CLEAR` : lifeCopy;
    const nextCopy = isWave ? `NEXT WAVE ${wave}` : "READY UP!";
    const progress = Math.max(0, Math.min(1, intermission.timer / intermission.duration));

    ctx.fillStyle = "rgba(5, 5, 5, 0.72)";
    ctx.fillRect(0, 0, W, H);
    drawPortraitCard(image, 52, 118, 420);
    drawText(kicker, 704, 178, 18, colors.muted, "center");
    drawText(intermission.message, 704, 272, 30, isWave ? colors.red : colors.beige, "center", true);
    drawText(nextCopy, 704, 344, 18, colors.paper, "center");
    drawText("SALLY SUPPLY", 704, 392, 14, colors.muted, "center");

    ctx.strokeStyle = colors.muted;
    ctx.lineWidth = 2;
    ctx.strokeRect(582, 452, 244, 18);
    ctx.fillStyle = isWave ? colors.red : colors.beige;
    ctx.fillRect(586, 456, Math.round(236 * (1 - progress)), 10);
  }

  function drawPaused() {
    drawText("PAUSED", W / 2, H / 2, 76, colors.red, "center", true);
    drawText("PRESS P TO RESUME", W / 2, H / 2 + 48, 15, colors.paper, "center");
  }

  function presentCrtCurve() {
    displayCtx.clearRect(0, 0, W, H);
    displayCtx.fillStyle = colors.black;
    displayCtx.fillRect(0, 0, W, H);
    displayCtx.imageSmoothingEnabled = true;
    displayCtx.globalCompositeOperation = "source-over";

    const slice = 3;
    const maxInset = 24;
    for (let y = 0; y < H; y += slice) {
      const centerY = (y + slice / 2) / H;
      const curve = (centerY - 0.5) * 2;
      const inset = Math.round(maxInset * curve * curve);
      displayCtx.globalAlpha = 0.025;
      displayCtx.drawImage(crtBuffer, 0, y, W, slice, inset - 0.3, y, W - inset * 2, slice + 0.15);
      displayCtx.globalAlpha = 0.02;
      displayCtx.drawImage(crtBuffer, 0, y, W, slice, inset + 0.3, y, W - inset * 2, slice + 0.15);
      displayCtx.globalAlpha = 0.98;
      displayCtx.drawImage(crtBuffer, 0, y, W, slice, inset, y, W - inset * 2, slice + 0.125);
    }
    displayCtx.globalAlpha = 1;
  }

  function draw() {
    ctx.fillStyle = colors.black;
    ctx.fillRect(0, 0, W, H);
    ctx.save();
    if (shakeTimer > 0) {
      const amount = 5 * (shakeTimer / 0.3);
      ctx.translate((Math.random() - 0.5) * amount, (Math.random() - 0.5) * amount);
    }
    ctx.strokeStyle = "rgba(245, 230, 211, 0.08)";
    ctx.lineWidth = 1;
    for (let x = 0; x < W; x += 24) {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, H);
      ctx.stroke();
    }
    for (let y = 0; y < H; y += 24) {
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(W, y);
      ctx.stroke();
    }

    if (state === "start") {
      drawStart();
      ctx.restore();
      presentCrtCurve();
      return;
    }

    if (state === "gameover") {
      drawGameOver();
      ctx.restore();
      presentCrtCurve();
      return;
    }

    if (state === "intermission") {
      drawIntermission();
      ctx.restore();
      presentCrtCurve();
      return;
    }

    drawHud();
    for (const enemy of enemies) drawEnemy(enemy);
    if (bonus) drawText("*", bonus.x + 23, bonus.y + 44, 58, colors.red, "center", true);
    ctx.fillStyle = colors.red;
    for (const bullet of bullets) ctx.fillRect(bullet.x, bullet.y, bullet.w, bullet.h);
    drawPlayer();
    drawControls();
    if (state === "paused") drawPaused();
    ctx.restore();
    if (flashTimer > 0) {
      ctx.fillStyle = `rgba(184, 58, 46, ${Math.min(0.18, flashTimer * 1.6)})`;
      ctx.fillRect(0, 0, W, H);
    }
    presentCrtCurve();
  }

  function loop(now) {
    const dt = Math.min(0.033, (now - lastTime) / 1000);
    lastTime = now;
    update(dt);
    draw();
    requestAnimationFrame(loop);
  }

  canvas.addEventListener("keydown", (event) => {
    if (leaderboardModalOpen) {
      if (event.key === "Escape") closeLeaderboardModal();
      event.preventDefault();
      return;
    }
    if ((event.key === "m" || event.key === "M") && audioContext) {
      soundEnabled = !soundEnabled;
      if (soundEnabled) playSound("start");
      return;
    }
    if (state === "start") {
      setArcadePageMode("focus");
      if ((event.key === "l" || event.key === "L") && hasSavedPlayer) {
        event.preventDefault();
        openLeaderboardModal({ source: canvas });
        return;
      }
      if (hasSavedPlayer) {
        if (event.key === "Enter") beginGame();
        if (event.key === "c" || event.key === "C") changePlayerDetails();
        return;
      }
      if (event.key === "Tab") {
        event.preventDefault();
        activeField = activeField === "email" ? "instagram" : "email";
        return;
      }
      if (event.key === "Enter") {
        beginGame();
        return;
      }
      if (event.key === "Backspace") {
        event.preventDefault();
        if (activeField === "email") email = email.slice(0, -1);
        if (activeField === "instagram") instagram = instagram.slice(0, -1);
        return;
      }
      if (event.key.length === 1) {
        if (activeField === "email" && /^[a-zA-Z0-9._+\-@]$/.test(event.key) && email.length < EMAIL_MAX_LENGTH) {
          email = sanitizeEmail(email + event.key);
        }
        if (activeField === "instagram" && /^[a-zA-Z0-9._@]$/.test(event.key) && instagram.length < INSTAGRAM_MAX_LENGTH) {
          instagram = sanitizeInstagram(instagram + event.key);
        }
      }
      return;
    }

    if (event.key === "p" || event.key === "P") {
      state = state === "paused" ? "playing" : state === "playing" ? "paused" : state;
      return;
    }
    if (state === "gameover") {
      if (event.key === "Enter") beginGame();
      if (event.key === "c" || event.key === "C") changePlayerDetails();
      if (event.key === "l" || event.key === "L") {
        event.preventDefault();
        openLeaderboardModal({ source: canvas });
      }
      return;
    }
    if (state === "intermission") return;
    if (event.key === " ") {
      event.preventDefault();
      if (!fireHeld && !event.repeat) shoot();
      fireHeld = true;
      return;
    }
    keys.add(event.key);
  });

  canvas.addEventListener("keyup", (event) => {
    if (event.key === " ") fireHeld = false;
    keys.delete(event.key);
  });

  for (const [field, input] of Object.entries(mobileEntryFields)) {
    input.addEventListener("focus", () => {
      activeField = field;
      syncMobileEntryInput(field);
      draw();
    });

    input.addEventListener("input", () => {
      if (field === "email") {
        email = sanitizeEmail(input.value);
        input.value = email;
        mobileEntrySubmit.disabled = !validEntry();
        draw();
        return;
      }
      instagram = sanitizeInstagram(input.value);
      input.value = instagram;
      mobileEntrySubmit.disabled = !validEntry();
      draw();
    });

    input.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (field === "email") {
          activeField = "instagram";
          focusMobileEntryInput();
        } else {
          beginGame();
        }
      }
    });
  }

  mobileEntryForm.addEventListener("submit", (event) => {
    event.preventDefault();
    beginGame();
  });

  mobileEntryLeaderboard.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    openLeaderboardModal({ source: mobileEntryLeaderboard });
  });

  canvas.addEventListener("pointerdown", (event) => {
    const point = pointerPosition(event);
    if (leaderboardModalOpen) {
      event.preventDefault();
      return;
    }
    if (state === "start") {
      if (hasSavedPlayer) {
        event.preventDefault();
        setArcadePageMode("focus");
        canvas.focus();
        if (pointInRect(point, startButton)) beginGame();
        if (pointInRect(point, changeDetailsButton)) changePlayerDetails();
        if (pointInRect(point, startLeaderboardButton)) openLeaderboardModal({ source: canvas });
        return;
      }
      if (shouldUseMobileEntryInputs()) {
        if (pointInRect(point, startLeaderboardButton)) openLeaderboardModal({ source: canvas });
        if (pointInRect(point, startButton)) beginGame();
        return;
      }
      setArcadePageMode("focus");
      if (pointInRect(point, emailBox)) {
        activeField = "email";
        focusMobileEntryInput();
        return;
      }
      if (pointInRect(point, instaBox)) {
        activeField = "instagram";
        focusMobileEntryInput();
        return;
      }
      event.preventDefault();
      canvas.focus();
      if (pointInRect(point, startLeaderboardButton)) {
        openLeaderboardModal({ source: canvas });
        return;
      }
      if (pointInRect(point, startButton)) beginGame();
      return;
    }
    event.preventDefault();
    canvas.focus();
    if (state === "gameover") {
      if (pointInRect(point, gameOverRestartButton)) beginGame();
      if (pointInRect(point, gameOverChangeButton)) changePlayerDetails();
      if (pointInRect(point, gameOverLeaderboardButton)) openLeaderboardModal({ source: canvas });
      return;
    }
    if (state === "intermission") return;
    const zones = getTouchZones(point);
    activePointers.set(event.pointerId, zones);
    syncTouchControls();
    if (zones.fire) shoot();
    canvas.setPointerCapture?.(event.pointerId);
  });

  canvas.addEventListener("pointermove", (event) => {
    if (state !== "playing") return;
    event.preventDefault();
    const point = pointerPosition(event);
    activePointers.set(event.pointerId, getTouchZones(point));
    syncTouchControls();
  });

  function endPointer(event) {
    activePointers.delete(event.pointerId);
    syncTouchControls();
  }

  function handleMobileEntryViewportChange() {
    if (mobileEntryInputIsFocused()) return;
    if (state === "start" && shouldUseMobileEntryInputs()) {
      setArcadePageMode("focus");
      return;
    }
    updateMobileEntryOverlays();
  }

  window.addEventListener("pointerup", endPointer);
  window.addEventListener("pointercancel", endPointer);
  window.addEventListener("resize", handleMobileEntryViewportChange);
  window.addEventListener("scroll", handleMobileEntryViewportChange, { passive: true });
  window.visualViewport?.addEventListener("resize", handleMobileEntryViewportChange, { passive: true });
  window.visualViewport?.addEventListener("scroll", handleMobileEntryViewportChange, { passive: true });

  document.fonts?.ready.then(draw);
  if (shouldUseMobileEntryInputs()) {
    setArcadePageMode("focus");
  } else {
    setArcadePageMode("attract");
    scheduleAttractZoom();
  }
  refreshLeaderboard();
  requestAnimationFrame(loop);
})();
